"use strict";
(function gridNamespace(global) {

  /**
  * Функции отвечающие за грид
  * @namespace Core.grid
  * @since 5.2.0.1100
  */
  global.grid = {};

  /**
  * Функции отвечающие за грид списка записей справочника.
  * @namespace Core.grid.reference
  * @since 5.2.0.1100
  */
  global.grid.reference = {};

  /**
  * Deferred-объект. Сообщает о готовности к использованию Core.grid.reference.
  * @namespace Core.grid.referenceInit
  * @since 5.4.0.1021
  */
  global.grid.referenceInit = $.Deferred();

  /**
  * Определяем место размещения грида
  * @method Core.grid.getPlacementContext
  * @return {String}
  */
  global.grid.getPlacementContext = function () {
    if (typeof g_ReferencePlacementContext !== 'undefined') {
      return g_ReferencePlacementContext;
    } else {
      var currentTab = WA.current.sideBar.tabs.current;
      if (!!currentTab) {
        var prefix;
        switch (WA.getLocation()) {
          case "reference": prefix = "RefCard"; break;
          case "doc": prefix = "DocCard"; break;
          case "task": prefix = "TaskCard"; break;
          case "job": prefix = "JobCard"; break;
          case "folder": prefix = "FolderCard"; break;
          default: prefix = "Card";
        }
        return prefix + '_' + currentTab.name.toUpperCase();
      }
      return 'Explorer';
    }
  }

})(window.Core);
